module.exports = __webpack_public_path__ + "static/media/invo-button.8e977cde.svg";